import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const twitter = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.653 4.268c.854-.52 1.493-1.336 1.8-2.297-.804.483-1.683.825-2.6 1.01-1.153-1.245-2.939-1.65-4.506-1.023-1.566.627-2.597 2.16-2.6 3.867.001.318.037.636.106.946-3.298-.168-6.37-1.748-8.453-4.346-.37.633-.563 1.355-.56 2.09-.117 1.34.452 2.647 1.507 3.463C1.608 7.87.88 7.696.173 7.458v.052c.142 2.038 1.63 3.717 3.614 4.077-.298.098-.608.147-.92.146-.233.001-.466-.024-.694-.074.55 1.699 2.103 2.858 3.867 2.888-1.446 1.158-3.237 1.786-5.08 1.78-.32 0-.641-.02-.96-.058 3.593 2.332 8.156 2.492 11.9.417 3.744-2.076 6.073-6.056 6.073-10.381 0-.18-.013-.36-.013-.54.801-.588 1.492-1.316 2.04-2.15-.745.336-1.536.556-2.347.653z"
  }
));

export { twitter as default };
//# sourceMappingURL=twitter.js.map
